<div>
    <div class="page-header">
        <div class="page-title-row">
            <h1 class="page-title">{{title}}</h1>

            <ng-content select="[page-actions]"></ng-content>

            <div class="page-actions-spacer"></div>

            <div class="start-convverse-container">
              <a
                href="https://companion.convverse.ai"
                target="_blank"
                rel="noopener"
                class="start-convverse-btn"
              >
                Start companion
              </a>
            </div>
        </div>
    </div>
    <ng-content></ng-content>
</div>
